exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vd-wrapper[data-v-cc519c84]{height:100vh}.vd[data-v-cc519c84]{width:100%;height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/projects/nest/node_modules/css-loader?minimize!F:/projects/nest/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc519c84","scoped":true,"hasInlineConfig":false}!F:/projects/nest/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/component/index.vue
// module id = 4
// module chunks = 0